var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M39.375 19.084L22.5 39.056 5.625 19.002c-2.018-2.781-2.813-4.66-2.813-7.232 0-4.797 3.453-9.114 8.438-9.155 4.1-.033 8.75 4.12 11.25 7.252 2.434-3.021 7.15-7.252 11.25-7.252 4.853 0 8.438 4.358 8.438 9.155 0 2.572-.63 4.59-2.813 7.314zM33.75 0c-4.687 0-8.234 2.728-11.25 5.58C19.627 2.553 15.937 0 11.25 0 4.65 0 0 5.63 0 11.77c0 3.293 1.36 5.664 2.85 7.893l17.483 20.792c1.962 2.06 2.333 2.06 4.295 0L42.15 19.663C43.903 17.434 45 15.063 45 11.77 45 5.63 40.35 0 33.75 0z"
});
var SvgHeartHollow = function SvgHeartHollow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartHollow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HeartHollow.59968319.svg";
export { ForwardRef as ReactComponent };